import React from 'react';
import ButtonExternalLinkProps from '../../types/ButtonExternalLinkProps';
import style from './Button.module.css';

/**
 * ## Display a link to an external website.
 *
 * This link is shown as a button.
 * This link is open in a new tab.
 *
 * @param {id} string
 * @param {css} string
 * @param {link} string
 * @param {children} React.ReactNode
 * @param {icon} string
 * @param {download} boolean
 * @returns
 */
function ButtonExternalLink({
  link,
  icon,
  children,
  id,
  download,
}: ButtonExternalLinkProps) {
  return (
    <a
      href={link}
      target="_blank noreferer"
      className={style.btn}
      data-icon={icon}
      id={id}
      download={download}
    >
      <span>{children}</span>
    </a>
  );
}

export default ButtonExternalLink;
